const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    kilometer: () =>
        __('kilometer'),
    distFrom: () =>
        __('<abbr:km> fra'),
    enterAddress: () =>
        __('Indtast adresse'),
    radius: () =>
        __('Radius'),
};
